"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = exports.Plane = exports.Spherical = exports.Sphere = exports.Box = void 0;
const Box_1 = require("./Box");
Object.defineProperty(exports, "Box", { enumerable: true, get: function () { return Box_1.Box; } });
const Plane_1 = require("./Plane");
Object.defineProperty(exports, "Plane", { enumerable: true, get: function () { return Plane_1.Plane; } });
const Sphere_1 = require("./Sphere");
Object.defineProperty(exports, "Sphere", { enumerable: true, get: function () { return Sphere_1.Sphere; } });
const Spherical_1 = require("./Spherical");
Object.defineProperty(exports, "Spherical", { enumerable: true, get: function () { return Spherical_1.Spherical; } });
const Triangle_1 = require("./Triangle");
Object.defineProperty(exports, "Triangle", { enumerable: true, get: function () { return Triangle_1.Triangle; } });
//# sourceMappingURL=index.js.map